import { defineStore } from 'pinia'



export const useModalsStore = defineStore({
    id: 'modals',
    state: () => ({
        showModalWhatsapp: false,
        showCountryModal: '',
        showShopModal: false,
    }),
    actions: {
    },

})